module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/cube/cube.png";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/cube/cube.png
// module id = 549
// module chunks = 0